import { createTheme } from '@mui/material/styles';
import Config from '../../config/index.json';

const theme = createTheme({
  typography: {
    fontSize: 12,
    fontFamily: 'CernMedium',
  },
  palette: {
    primary: {
      main: '#B72755',
      light: '#B72755',
    },
    secondary: {
      main: '#333996',
      light: '#3c44b126',
    },
    background: {
      default: '#f4f5fd',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        transform: 'translateZ(0)',
      },
    },
    MuiOutlinedInputLabel: {
      outlined: {
        transform: 'translateZ(0)',
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: Config.breakpoints.sm,
      md: Config.breakpoints.md,
      lg: Config.breakpoints.lg,
      xl: Config.breakpoints.xl,
    },
  },
});

export default theme;
